/**
 *  Resolve some common HTML issues to follow standartds. Was created for migration between legacy HTML code created by
 *  FCEditor so code can be parsed by CKEditor, which is require to follow some rules, i.e. <ol> should not have <p> inside
 */
const htmlSanitizer = {

    sanitize(html) {
        const parser = new DOMParser();
        const document = parser.parseFromString(html, "text/html");

        this.processList(document);
        this.processCode(document);

        const processedValue = document.querySelector("body").innerHTML;

        return processedValue;
    },
  
    /**
     * Process OL elements, move all non-li items outside of OL list (next sibling)
     * @param {Document} document 
     */
    processList(document) {
        var lists = document.getElementsByTagName('ol');
        for(let i = 0; i < lists.length; i++) {
            let nodeToInsertAfter = lists[i];
            const copyOfChildNodes = Array.from(lists[i].childNodes);
            for(const item of copyOfChildNodes){
                if(item.tagName !== 'LI') {
                    nodeToInsertAfter.after(item);
                    nodeToInsertAfter = item;
                }
            }
        }
    },

    /**
     * Process CODE elements:
     * 1. If block is in parent <p>, it will be moved out (previous sibling to <p>)
     * 2. Will replace all <div>, <p> elements inside <code> with <span>
     * @param {Document} document 
     */
     processCode(document) {
        const childTagsToMove = ['DIV', 'P']

        var codeBlocks = document.getElementsByTagName('code');
        for(let i = 0; i < codeBlocks.length; i++) {
            
            let codeBlock = codeBlocks[i];
            //console.log(codeBlock);
            const copyOfChildNodes = Array.from(codeBlock.childNodes);
            for(const item of copyOfChildNodes){
                if(childTagsToMove.includes(item.tagName)) {
                    const copyOfDivChildNodes = Array.from(item.childNodes);
                    for(const divChild of copyOfDivChildNodes) {
                        let isNextBr = divChild.nextSibling !== null && divChild.nextSibling.tagName === 'BR';
                        let isLastInPar = divChild.parentNode.tagName === 'P' && divChild.nextSibling === null;

                        item.before(divChild);

                        if(isLastInPar) {
                            item.before(document.createElement('br'));
                        }
                        if(divChild.nodeName === '#text' && !isNextBr) {
                            item.before(document.createElement('br'));
                        }
                    }

                    // For empty paragraph add <br> separator
                    if(copyOfDivChildNodes.length === 0 && item.tagName === 'P' && 
                        (item.previousSibling === null || item.previousSibling.nodeName != 'BR')) {
                        item.before(document.createElement('br'));
                    }

                    item.remove();
                } 
                else if (item.nodeName === '#text') {
                    let val = item.data;
                    item.data = val.replace(/ /g, '\u00a0'); // Replace spaces with &nbsp;
                }
            }

            if(codeBlock.parentElement.tagName === 'P') {
                codeBlock.parentElement.before(codeBlock);
            }
        }
    }
  }
  
  export default htmlSanitizer;